import { createAsyncThunk } from '@reduxjs/toolkit';
import { BrowseNodeAPI } from './browseNodeAPI';

export const fetchBrowseNodes = createAsyncThunk('browseNodes/fetchBrowseNodes', async () => {
  const response = await BrowseNodeAPI.fetchBrowseNodes();
  return response.data;
});
export const fetchImpactMetrics = createAsyncThunk('browseNodes/fetchImpactMetrics', async () => {
  const response = await BrowseNodeAPI.fetchImpactMetrics();
  return response.data;
});
export const fetchBrowseNodeMaterials = createAsyncThunk(
  'browseNodes/fetchBrowseNodeMaterial',
  async () => {
    const response = await BrowseNodeAPI.fetchBrowseNodeMaterials();
    return response.data;
  }
);
